import { FieldCheckbox } from './field-checkbox';
import { FieldDate } from './field-date';
import { FieldDropdown } from './field-dropdown';
import { FieldFile } from './field-file';
import { FieldInput } from './field-input';
import { FieldKeyValue } from './field-key-value';
import { FieldRadio } from './field-radio';
import { FieldRadioGroup } from './field-radio-group';
import { FieldTextarea } from './field-textarea';

export const Field = {
  Checkbox: FieldCheckbox,
  Date: FieldDate,
  Dropdown: FieldDropdown,
  File: FieldFile,
  Input: FieldInput,
  KeyValue: FieldKeyValue,
  Radio: FieldRadio,
  RadioGroup: FieldRadioGroup,
  Textarea: FieldTextarea,
};

export { FieldError } from './field-error';

export * from './field.types';
